import { useState } from 'react';
import img from '../images/Download_on_the_App_Store_Badge.svg';
import {
  FaCopyright,
  FaEnvelope,
  FaGithubAlt,
  FaLinkedin,
} from 'react-icons/fa';
import { Link } from 'react-router';

export default function Footer() {
  const [year] = useState(() => new Date().getFullYear());
  return (
    <footer className='border-slat-950 mt-8 h-52 w-full border-t border-solid p-4 dark:border-white'>
      <div className='flex h-full w-full flex-row flex-wrap items-center justify-around'>
        <div style={{ width: '200px' }}>
          <a href='https://play.google.com/store/apps/details?id=com.brandonlehr.alpacatracker&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img
              width='200'
              alt='Get it on Google Play'
              src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'
            />
          </a>
        </div>

        <div style={{ width: '170px' }}>
          <a href='https://apps.apple.com/us/app/alpaca-tracker/id1462547727'>
            <img
              src={img}
              alt='Download on the App Store'
              style={{ width: '100%' }}
            />
          </a>
        </div>

        <div className=''>
          <a href='http://brandonlehr.com' className='text-xl hover:opacity-70'>
            <div className='flex items-center'>
              <FaCopyright /> <span className='p-2.5'>{year} Brandon Lehr</span>
            </div>
          </a>
        </div>
        <div>
          <Link to='/privacy-policy'>Privacy Policy</Link> <span> / </span>
          <Link to='/terms-of-use'>Terms of Use</Link>
        </div>
        <div className='flex items-center'>
          <a
            href='https://www.linkedin.com/in/brandonlehr/'
            className='p-2.5 text-3xl hover:opacity-70'
          >
            <FaLinkedin aria-hidden='true' />
          </a>
          <a
            href='https://github.com/blehr'
            className='p-2.5 text-3xl hover:opacity-70'
          >
            <FaGithubAlt aria-hidden='true' />
          </a>
          <a
            href='mailto:blehr.mail@gmail.com'
            className='p-2.5 text-3xl hover:opacity-70'
          >
            <FaEnvelope aria-hidden='true' />
          </a>
        </div>
      </div>
    </footer>
  );
}
